export default __webpack_public_path__ + "static/media/b3.d034cf9d.png";